"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const mark_parser_1 = __importDefault(require("@gojipress/mark-parser"));
const mark_renderer_html_1 = __importDefault(require("@gojipress/mark-renderer-html"));
const unorderedListItem_1 = __importDefault(require("../../../parsers/block/container/unorderedListItem"));
const mark_parser_2 = require("@gojipress/mark-parser");
const codeSpan_1 = __importDefault(require("../../../parsers/inline/codeSpan"));
const emphasis_1 = __importDefault(require("../../../parsers/inline/emphasis"));
const link_1 = __importDefault(require("../../../parsers/inline/link"));
const strong_1 = __importDefault(require("../../../parsers/inline/strong"));
const unorderedListItem_2 = __importDefault(require("../../../renderers/html/unorderedListItem"));
const blankLine_1 = __importDefault(require("../../../renderers/html/blankLine"));
const paragraph_1 = __importDefault(require("../../../renderers/html/paragraph"));
const codeSpan_2 = __importDefault(require("../../../renderers/html/codeSpan"));
const emphasis_2 = __importDefault(require("../../../renderers/html/emphasis"));
const link_2 = __importDefault(require("../../../renderers/html/link"));
const strong_2 = __importDefault(require("../../../renderers/html/strong"));
const text_1 = __importDefault(require("../../../renderers/html/text"));
const definitionCustomPlugin = {
    id: "definition",
    name: "Definition Custom Plugin",
    pluginType: "custom",
    render: (data) => {
        const parser = new mark_parser_1.default();
        const renderer = new mark_renderer_html_1.default();
        parser.use(unorderedListItem_1.default);
        parser.use(mark_parser_2.plugins.blankLine);
        parser.use(mark_parser_2.plugins.paragraph);
        parser.use(codeSpan_1.default);
        parser.use(emphasis_1.default);
        parser.use(link_1.default);
        parser.use(strong_1.default);
        parser.use(mark_parser_2.plugins.text);
        renderer.use(unorderedListItem_2.default);
        renderer.use(blankLine_1.default);
        renderer.use(paragraph_1.default);
        renderer.use(codeSpan_2.default);
        renderer.use(emphasis_2.default);
        renderer.use(link_2.default);
        renderer.use(strong_2.default);
        renderer.use(text_1.default);
        const parsedOutput = parser.parse(data);
        const renderedOutput = renderer.render(parsedOutput);
        const container = document.createElement("div");
        container.classList.add("gmCustomDefinition");
        container.appendChild(renderedOutput);
        return container;
    },
};
exports.default = definitionCustomPlugin;
